import { LOADING_STATE } from "types/general";
import {
  IResearchState,
  ResearchStageEnum,
  ResearchWorkTypeEnum,
} from "./types";

export const RESEARCH_SLICE_NAME = "research";

export const initialState: IResearchState = {
  referenceData: { loadingState: LOADING_STATE.idle },
  summary: { loadingState: LOADING_STATE.idle },
  workItems: { data: [], loadingState: LOADING_STATE.idle },
  clientProgress: { data: [], loadingState: LOADING_STATE.idle },
  selectedPath: { loadingState: LOADING_STATE.idle },
  propertyHistory: { data: [], loadingState: LOADING_STATE.idle },
  productivity: { loadingState: LOADING_STATE.idle },
  intake: { loadingState: LOADING_STATE.idle },
};

export const RESEARCH_STAGE_LABELS: Record<ResearchStageEnum, string> = {
  [ResearchStageEnum.INTAKE_QUEUE]: "Intake Queue",
  [ResearchStageEnum.ABOVE_BOARD_CONVERSATION]: "Above Board Conversation",
  [ResearchStageEnum.SHOP_QUEUE]: "Shop Queue",
  [ResearchStageEnum.SHOP_IN_PROCESS]: "Shop In Process",
  [ResearchStageEnum.RETRY_QUEUE]: "Retry Queue",
  [ResearchStageEnum.RETRY_IN_PROCESS]: "Retry In Process",
  [ResearchStageEnum.READY_FOR_REVIEW]: "Ready for Review",
  [ResearchStageEnum.REQUIRES_FIX]: "Requires Fix",
  [ResearchStageEnum.COMPLETED]: "Completed",
};

export const RESEARCH_STAGE_SHORT_LABELS: Record<ResearchStageEnum, string> = {
  ...RESEARCH_STAGE_LABELS,
  [ResearchStageEnum.ABOVE_BOARD_CONVERSATION]: "Above Board",
};

export const RESEARCH_STAGE_ORDER = Object.values(ResearchStageEnum);

export const RESEARCH_WORK_TYPE_LABELS: Record<ResearchWorkTypeEnum, string> = {
  [ResearchWorkTypeEnum.TIME_SENSITIVE_REQUEST]: "ASAP",
  [ResearchWorkTypeEnum.SCHEDULED_SHOP_ROUND]: "Scheduled Shops",
};

export const CLAIMABLE_STAGES = new Set<ResearchStageEnum>([
  ResearchStageEnum.INTAKE_QUEUE,
  ResearchStageEnum.SHOP_QUEUE,
  ResearchStageEnum.RETRY_QUEUE,
]);

export const UNCLAIMABLE_STAGES = new Set<ResearchStageEnum>([
  ResearchStageEnum.ABOVE_BOARD_CONVERSATION,
  ResearchStageEnum.SHOP_IN_PROCESS,
  ResearchStageEnum.RETRY_IN_PROCESS,
]);
